<template>
    <div :class="['allot_pop_right_mask', 'animated', showAnimated ? 'findinMask' : 'findOutMask']" v-if="allotPopRightOkShow">
        <div :class="['allot_pop_right', 'animated', showAnimated ? 'fadeInRightBig' : 'fadeOutRightBig']">
            <div class="allot_title">
                <p>为下列设备分配<span style="color: #4c84e8;">
                  {{(allotType === 'pic' ? '广告' : (allotType === 'picFirst' ? '分屏顶部广告' : (allotType === 'wx' ? '公众号'
                  : (allotType === 'video' ? '视频' : (allotType === 'sale' ? '销售'
                  : (allotType === 'picFu' ? '副屏广告' : (allotType === 'bussiness' ? '商户' : '运营')))))))}}</span></p>
                <span v-for="item in deviceList" :key="item.num">{{item.num}}</span>
            </div>
             <pu-allot-ad-pic
                v-if="allotType === 'pic'"
                :device-list="deviceList"
                :allot-type="allotType"
                @boxColose="boxColose">
            </pu-allot-ad-pic>
            <pu-allot-ad-pic
               v-if="allotType === 'picFirst'"
               :device-list="deviceList"
               :allot-type="allotType"
               @boxColose="boxColose">
           </pu-allot-ad-pic>

           <pu-allot-ad-pic
               v-if="allotType === 'picFu'"
               :device-list="deviceList"
               :allot-type="allotType"
               @boxColose="boxColose">
           </pu-allot-ad-pic>
             <pu-allot-ad-video
                v-else-if="allotType === 'video'"
                :device-list="deviceList"
                :allot-type="allotType"
                @boxColose="boxColose">
            </pu-allot-ad-video>
            <pu-allot-weixin
                v-else-if="allotType === 'wx'"
                :device-list="deviceList"
                @boxColose="boxColose">
            </pu-allot-weixin>
            <pu-allot-ad-sale
                v-else-if="allotType === 'sale'"
                :device-list="deviceList"
                :the-type="5"
                @boxColose="boxColose">
            </pu-allot-ad-sale>
            <pu-allot-ad-sale
                v-else-if="allotType === 'bussiness'"
                :device-list="deviceList"
                :the-type="4"
                @boxColose="boxColose">
            </pu-allot-ad-sale>
            <pu-allot-ad-sale
                v-else-if="allotType === 'operate'"
                :device-list="deviceList"
                :the-type="3"
                @boxColose="boxColose">
            </pu-allot-ad-sale>

            <span @click="boxColose"
            style="position: absolute; top: 0;left:0;padding:10px;color:#FF4949">
            <i class="el-icon-close Danger"></i></span>
        </div>
    </div>
</template>
<script>
    import puAllotAdPic from '@/page/deviceMgr/allotAdPic'
    import puAllotAdVideo from '@/page/deviceMgr/allotAdVideo'
    import puAllotAdWeixin from '@/page/deviceMgr/allotWeixin'
    import puAllotAdSale from '@/page/deviceMgr/allotAdSale'

    export default {
      props: ['allotPopRightOk', 'deviceList', 'allotType'],
      data () {
        return {
          showAnimated: true
        }
      },
      computed: {
        allotPopRightOkShow: function () {
          this.showAnimated = true
          return this.allotPopRightOk
        //   return true
        },
        allotDeviceList: function () {
          return this.deviceList
        }
      },
      methods: {
        boxColose () {
          this.showAnimated = false
          var _this = this
          setTimeout(function () {
            _this.$emit('closeAllotRightPop', false)
          }, 500)
        }
      },
      components: {
        'pu-allot-ad-pic': puAllotAdPic,
        'pu-allot-ad-video': puAllotAdVideo,
        'pu-allot-weixin': puAllotAdWeixin,
        'pu-allot-ad-sale': puAllotAdSale
      }
    }
</script>
<style lang="scss">
  .allot_pop_right_mask {
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      position: fixed;
      background: rgba(#000, 0.3);
      z-index: 200;
  }
  .allot_pop_right {
    top: 0;
    right: 0;
    left: 20%;
    bottom: 0;
    z-index: 201;
    position: fixed;
    background: #eef1f6;

    .allot_title {
        background: white;
        padding: 10px;
        border-bottom: 1px solid #ccc;

        p {
            margin:0;
            padding: 5px;
            color: black;
            font-size: 20px;
            font-weight: 500;
        }
        span {
            margin-right: 10px;
        }
    }
  }

  .animated {
      -webkit-animation-duration: 1s;
      animation-duration: 1s;
      -webkit-animation-fill-mode: both;
      animation-fill-mode: both;
    }

    .animated.infinite {
      -webkit-animation-iteration-count: infinite;
      animation-iteration-count: infinite;
    }

    .animated.hinge {
      -webkit-animation-duration: 2s;
      animation-duration: 2s;
    }

    @-webkit-keyframes fadeInRightBig {
      0% {
        opacity: 0.5;
        -webkit-transform: translateX(2000px);
        transform: translateX(2000px);
      }

      100% {
        opacity: 1;
        -webkit-transform: translateX(0);
        transform: translateX(0);
      }
    }

    @keyframes fadeInRightBig {
      0% {
        opacity: 0.5;
        -webkit-transform: translateX(2000px);
        -ms-transform: translateX(2000px);
        transform: translateX(2000px);
      }

      100% {
        opacity: 1;
        -webkit-transform: translateX(0);
        -ms-transform: translateX(0);
        transform: translateX(0);
      }
    }

    .fadeInRightBig {
      -webkit-animation-name: fadeInRightBig;
      animation-name: fadeInRightBig;
    }

    @-webkit-keyframes findinMask {
      0% {
        opacity: 0;
      }

      100% {
        opacity: 1;
      }
    }

    @keyframes findinMask {
      0% {
        opacity: 0;
      }

      100% {
        opacity: 1;
      }
    }
    .findinMask {
      -webkit-animation-name: findinMask;
      animation-name: findinMask;
    }



    @-webkit-keyframes fadeOutRightBig {
      0% {
        opacity: 1;
        -webkit-transform: translateX(0);
        transform: translateX(0);
      }

      100% {
        opacity: 0.5;
        -webkit-transform: translateX(2000px);
        transform: translateX(2000px);
      }
    }

    @keyframes fadeOutRightBig {
      0% {
        opacity: 1;
        -webkit-transform: translateX(0);
        -ms-transform: translateX(0);
        transform: translateX(0);
      }

      100% {
        opacity: 0.5;
        -webkit-transform: translateX(2000px);
        -ms-transform: translateX(2000px);
        transform: translateX(2000px);
      }
    }

    .fadeOutRightBig {
      -webkit-animation-name: fadeOutRightBig;
      animation-name: fadeOutRightBig;
    }

    @-webkit-keyframes findOutMask {
      0% {
        opacity: 1;
      }

      100% {
        opacity: 0;
      }
    }

    @keyframes findOutMask {
      0% {
        opacity: 1;
      }

      100% {
        opacity: 0;
      }
    }
    .findOutMask {
      -webkit-animation-duration: 0.5s;
      animation-duration: 0.5s;
      -webkit-animation-name: findOutMask;
      animation-name: findOutMask;
    }
</style>



// WEBPACK FOOTER //
// src/page/deviceMgr/allotPopRight.vue